const apiEndPoint = "/organisation";

/**
 * Sollte mit useHttp abgerufen werden
 * @type {string}
 */
export const getOrganisationenRegisterEndpoint = apiEndPoint + "/auswahlRegistrierung/";

export const getOrganisationenEndpoint = apiEndPoint + "?status=AKTIV";

export const getBetreiberEndpoint = apiEndPoint + "/betreiber";

export const getBetreiberPersonalisiertEndpoint = apiEndPoint + "/betreiberPersonalisiert";

export function getBetreiberByBetriebstypEndpoint(betriebstyp) {
    return apiEndPoint + "/betreiberByBetriebstyp/" + betriebstyp;
}

export const getAbwasserbeseitigungspflichtigeEndpoint = apiEndPoint + "/abwasserbeseitigungspflichtige";

export const getAbwasserbeseitigungspflichtigeEndpointIncludeHistory = apiEndPoint + "/abwasserbeseitigungspflichtigeIncludeHistory";

export const getAlleOrganisationenEndpoint = apiEndPoint;

export function getOrganisationenByIdEndpoint(organisationsId) {
    return apiEndPoint + "/" + organisationsId;
}

export const postOrganisationFusionEndpoint = apiEndPoint + "/merge/";

export function postOrganisationenExportEndpointConfiguration(selectedIds) {
    return {
        url: apiEndPoint + "/export/",
        method: "POST",
        data: selectedIds,
        responseType: "blob",
    };
}

export function getOrganisationsHistorie(organisationsId) {
    return `${apiEndPoint}/${organisationsId}/historie/`;
}
